import { action, observable } from 'mobx'
import { StickyTree } from 'react-virtualized-sticky-tree'

export class ElementRefStore {
  @observable.struct ref: StickyTree

  constructor() {
    this.setRef = this.setRef.bind(this)
  }

  @action
  setRef(ref: StickyTree) {
    this.ref = ref
  }
}
